import { createContext, useContext } from 'react';
import { type StoreApi, useStore } from 'zustand';
import type { DocItemsStore } from '../interfaces';

type Store = StoreApi<DocItemsStore>;

export const DocItemsContext = createContext<Store | null>(null);

export const useDocItemsContext = <T>(
  selector: (state: DocItemsStore) => T,
) => {
  const context = useContext(DocItemsContext);

  if (!context)
    throw new Error(
      'useDocItemsContext must be used inside DocItemsContextProvider',
    );

  return useStore(context, selector);
};
